import { createSelector } from '@ngrx/store';

import { RootState } from '../root-store/root.state';

export const selectSeSignFeatureState = (state: RootState) => state.sign;

export const selectSeSignOtpSms = createSelector(selectSeSignFeatureState, (state) => state.otpSms);
